import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { useSelector } from "react-redux"
import { ReduxState } from "model/state"
import { Uuid } from "helpers/types/uuid"

const EMPTY_FEATURES: Record<string, boolean> = {}

export function useAccountAlias(): string {
  return useSelector((state: ReduxState) => state.global.selected.account)
}

export function useAccountId(): Uuid {
  return useSelector((state: ReduxState) => state.global.selected.accountId)
}

export function useDefaultCurrencyId(): string {
  return useSelector((state: ReduxState) => get(state, "global.selected.accountMeta.defaultCurrency"))
}

export function useIsOpPro(): boolean | undefined {
  return useSelector(getIsOpPro)
}

export function useEnabledFeatures() {
  return useSelector((state: ReduxState) => get(state, "global.data.enabledFeatures.data", EMPTY_FEATURES))
}

export function useIsEndVsStartDateComparisonEnabled(): boolean {
  const enabledFeatures = useEnabledFeatures()
  return enabledFeatures.end_vs_start ?? false
}

export function useIsAiTermsAccepted(): boolean {
  return useSelector((state: ReduxState) => get(state, "global.data.aiTermsAndConditions.data.enabled", false))
}

export function useIsDashboardOptimizeExperimentsFeatureEnabled(): boolean {
  const enabledFeatures = useEnabledFeatures()
  return enabledFeatures.optimize_experiments ?? false
}

export function useIsDashboardOpLayoutEnabled(): boolean {
  const enabledFeatures = useEnabledFeatures()
  return enabledFeatures.dashboard_op_layout ?? false
}

export function useIsAiChatFeatureEnabled(): boolean {
  const enabledFeatures = useEnabledFeatures()
  return enabledFeatures?.ai_chat ?? false
}

export function useIsBattingSluggingEnabled(): boolean {
  const enabledFeatures = useEnabledFeatures()
  return enabledFeatures.batting_slugging ?? false
}
